import { render, staticRenderFns } from "./legalList.vue?vue&type=template&id=3959bc80&"
import script from "./legalList.vue?vue&type=script&lang=js&"
export * from "./legalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports